module.exports = __webpack_public_path__ + "static/media/KestrelMet_6000AG_station.051e9c9e.jpg";